import global from './Globals';

const Modal = {
  modalBg: global.white,
  modalCloseBg: global.white,
  modalCloseText: global.black,
};

export default Modal;
